import styled from 'styled-components';

import { SSelectivityCriterionInfo } from './SelectivityCriterionInfo';

const SSelectivityDetails = styled.div`
  .criteria-group,
  .combined-container,
  .criteria-container {
    border-radius: 10px;
    padding: 15px 10px;
  }

  .criteria-container {
    border: 1.5px solid ${({ theme }) => theme.colors.quaternaryBackground};
  }

  .criteria-group {
    background: ${({ theme }) => theme.colors.quaternaryBackground};
  }

  .combined-container {
    background: ${({ theme }) => theme.colors.primaryText};
    position: relative;

    &::before {
      color: ${({ theme }) => theme.colors.quaternaryText};
      content: 'Combined Selectivity';
      display: block;
      margin-bottom: 10px;
    }

    &::after {
      color: ${({ theme }) => theme.colors.quaternaryText};
      content: attr(data-combId);
      font-size: 12 px;
      position: absolute;
      right: 15px;
      top: 15px;
    }
  }

  * + ${SSelectivityCriterionInfo}, * + .combined-container {
    margin-top: 10px;
  }
`;

export default SSelectivityDetails;
